import React, { useState, useRef, useEffect } from 'react'
import Title from '../layout/Title'
import ContactLeft from './ContactLeft'
import emailjs from '@emailjs/browser'

const Contact = () => {
  const [username, setUsername] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const form = useRef()

  const emailValidation = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

  const handleSend = (e) => {
    e.preventDefault()

    const nameTrimmed = username.trim()
    const phoneTrimmed = phoneNumber.trim()
    const emailTrimmed = email.trim()
    const subjectTrimmed = subject.trim()
    const messageTrimmed = message.trim()

    if (!nameTrimmed) return setErrMsg('Username is required!')
    if (!phoneTrimmed) return setErrMsg('Phone number is required!')
    if (!emailTrimmed) return setErrMsg('Please give your Email!')
    if (!emailValidation(emailTrimmed)) return setErrMsg('Give a valid Email!')
    if (!subjectTrimmed) return setErrMsg('Please give your Subject!')
    if (!messageTrimmed) return setErrMsg('Message is required!')

    setErrMsg('')

    emailjs
      .send(
        'service_5jkpksw',       // Your EmailJS service ID
        'template_svywex4',      // Your EmailJS template ID
        {
          to_name: 'Admin',       // You can hardcode or get from your context
          name: nameTrimmed,
          email: emailTrimmed,
          phone: phoneTrimmed,
          subject: subjectTrimmed,
          message: messageTrimmed,
        },
        'bcbYXWuVCNfx3ow9D'     // Your EmailJS public key
      )
      .then(
        (result) => {
          setSuccessMsg(`Thank you, ${nameTrimmed}! Your message has been sent.`)
          setUsername('')
          setPhoneNumber('')
          setEmail('')
          setSubject('')
          setMessage('')
        },
        (error) => {
          console.error('EmailJS Error:', error)
          setErrMsg('Something went wrong. Please try again or reconnect EmailJS.')
        }
      )
  }

  useEffect(() => {
    if (successMsg) {
      const timer = setTimeout(() => setSuccessMsg(''), 5000)
      return () => clearTimeout(timer)
    }
  }, [successMsg])

  return (
    <section id="contact" className="w-full py-20 border-b border-black">
      <div className="text-center mb-10">
        <Title title="CONTACT" des="Contact With Me" />
      </div>
      <div className="flex flex-col lg:flex-row gap-8">
        <ContactLeft />
        <div className="w-full lg:w-3/5 bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-lg">
          <form onSubmit={handleSend} className="flex flex-col gap-6">
            {errMsg && (
              <p className="p-3 bg-red-800 text-center text-orange-400 rounded">{errMsg}</p>
            )}
            {successMsg && (
              <p className="p-3 bg-green-800 text-center text-green-300 rounded">{successMsg}</p>
            )}

            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1">
                <label className="text-gray-400 uppercase text-sm">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full mt-1 p-2 bg-[#141518] rounded outline-none"
                />
              </div>
              <div className="flex-1">
                <label className="text-gray-400 uppercase text-sm">Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="w-full mt-1 p-2 bg-[#141518] rounded outline-none"
                />
              </div>
            </div>

            <div>
              <label className="text-gray-400 uppercase text-sm">Email</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 p-2 bg-[#141518] rounded outline-none"
              />
            </div>

            <div>
              <label className="text-gray-400 uppercase text-sm">Subject</label>
              <input
                type="text"
                name="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full mt-1 p-2 bg-[#141518] rounded outline-none"
              />
            </div>

            <div>
              <label className="text-gray-400 uppercase text-sm">Message</label>
              <textarea
                name="message"
                rows="6"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full mt-1 p-2 bg-[#141518] rounded outline-none"
              />
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-[#141518] rounded uppercase tracking-wider hover:border hover:border-designColor transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
